<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="MFP MX532, MX632, XM3350">
     MFP MX532, MX632, XM3350
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_it" title="Informazioni sulla sicurezza">
     Informazioni sulla sicurezza
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="Convenzioni">
      Convenzioni
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-cable-topic.html#d0e40" title="Dichiarazioni relative al prodotto">
      Dichiarazioni relative al prodotto
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learning-about-printer-chapter.html#learning-about-printer-chapter_it" title="Informazioni sulla stampante">
     Informazioni sulla stampante
    </a>
   </p>
   <div id="divd0e175">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_it" title="Individuazione delle informazioni sulla stampante">
      Individuazione delle informazioni sulla stampante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="finding-printer-serial-number-topic.html#finding-printer-serial-number_it" title="Individuazione del numero di serie della stampante">
      Individuazione del numero di serie della stampante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-configurations-topic.html#printer-configurations_it" title="Configurazioni della stampante">
      Configurazioni della stampante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_it" title="Tramite il pannello di controllo">
      Tramite il pannello di controllo
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-status-of-power-button-and-indicator-light-topic.html#understanding-status-of-power-button-and-indicator-light_it" title="Informazioni sullo stato della spia luminosa">
      Informazioni sullo stato della spia luminosa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="selecting-paper-group.html#d0e500" title="Scelta della carta">
      Scelta della carta
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_it" title="Impostazione, installazione e configurazione">
     Impostazione, installazione e configurazione
    </a>
   </p>
   <div id="divd0e1569">
    <p class="toc-2-style">
     <a href="selecting-location-printer-topic.html#selecting-location-printer_it" title="Scelta della posizione della stampante">
      Scelta della posizione della stampante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="attaching-cables-topic.html#attaching-cables_it" title="Collegamento dei cavi">
      Collegamento dei cavi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-home-screen-topic.html#d0e1764" title="Impostazione e uso delle applicazioni della schermata iniziale">
      Impostazione e uso delle applicazioni della schermata iniziale
     </a>
    </p>
    <p class="toc-2-style">
     <a href="activating-voice-guidance-topic.html#d0e2411" title="Configurazione e utilizzo delle funzioni di accessibilit&agrave;">
      Configurazione e utilizzo delle funzioni di accessibilit&agrave;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-printer-to-fax-group.html#d0e2717" title="Impostazione della stampante in modalit&agrave; fax">
      Impostazione della stampante in modalit&agrave; fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-smtp-server-for-e-mail-topic.html#configuring-smtp-server-for-e-mail_it" title="Configurazione delle impostazioni SMTP e-mail">
      Configurazione delle impostazioni SMTP e-mail
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-paper-size-and-type-topic.html#d0e4576" title="Caricamento della carta e dei supporti speciali">
      Caricamento della carta e dei supporti speciali
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e4742" title="Installazione e aggiornamento di software, driver e firmware">
      Installazione e aggiornamento di software, driver e firmware
     </a>
    </p>
    <p class="toc-2-style">
     <a href="available-internal-options-topic.html#d0e5023" title="Installazione delle opzioni hardware">
      Installazione delle opzioni hardware
     </a>
    </p>
    <p class="toc-2-style">
     <a href="wireless-support-topic.html#d0e5332" title="Collegamento in rete">
      Collegamento in rete
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-the-printer.html#securing-the-printer_it" title="Protezione della stampante">
     Protezione della stampante
    </a>
   </p>
   <div id="divd0e5757">
    <p class="toc-2-style">
     <a href="locating-security-slot-topic.html#locating-security-slot_it" title="Individuazione dello slot di sicurezza">
      Individuazione dello slot di sicurezza
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_it" title="Cancellazione della memoria della stampante">
      Cancellazione della memoria della stampante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-storage-drive-topic.html#erasing-printer-storage-drive_it" title="Cancellazione dell'unit&agrave; di archiviazione della stampante">
      Cancellazione dell'unit&agrave; di archiviazione della stampante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_it" title="Ripristino delle impostazioni predefinite di fabbrica">
      Ripristino delle impostazioni predefinite di fabbrica
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-topic.html#statement-of-volatility_it" title="Dichiarazione di volatilit&agrave;">
      Dichiarazione di volatilit&agrave;
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printing-chapter.html#printing-chapter_it" title="Stampa">
     Stampa
    </a>
   </p>
   <div id="divd0e5950">
    <p class="toc-2-style">
     <a href="printing-from-computer-h2-topic.html#printing-from-computer-h2_it" title="Stampa da un computer">
      Stampa da un computer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-topic.html#d0e5976" title="Stampa da un dispositivo mobile">
      Stampa da un dispositivo mobile
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-topic.html#printing-from-flash-drive_it" title="Stampa da un'unit&agrave; flash">
      Stampa da un'unit&agrave; flash
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-flash-drives-and-file-types-topic.html#supported-flash-drives-and-file-types_it" title="Unit&agrave; flash e tipi di file supportati">
      Unit&agrave; flash e tipi di file supportati
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_it" title="Configurazione di processi riservati">
      Configurazione di processi riservati
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_it" title="Stampa di processi riservati e in attesa">
      Stampa di processi riservati e in attesa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-h2-topic.html#printing-font-sample-list-h2_it" title="Stampa di un elenco di esempi di font">
      Stampa di un elenco di esempi di font
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-directory-list-h2-topic.html#printing-directory-list-h2_it" title="Stampa di un elenco di directory">
      Stampa di un elenco di directory
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-topic.html#placing-separator-sheets_it" title="Inserimento di fogli separatori tra copie">
      Inserimento di fogli separatori tra copie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_it" title="Annullamento di un processo di stampa">
      Annullamento di un processo di stampa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-toner-darkness-topic.html#adjusting-toner-darkness_it" title="Regolazione dell'intensit&agrave; del toner">
      Regolazione dell'intensit&agrave; del toner
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="copying.html#copying_it" title="Copia">
     Copia
    </a>
   </p>
   <div id="divd0e6566">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-copy-topic.html#using-ADF-and-scanner-glass-copy_it" title="Uso dell'alimentatore automatico documenti e del vetro dello scanner">
      Uso dell'alimentatore automatico documenti e del vetro dello scanner
     </a>
    </p>
    <p class="toc-2-style">
     <a href="making-copies-topic.html#making-copies_it" title="Esecuzione di copie">
      Esecuzione di copie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-photos-topic.html#copying-photos_it" title="Copia di fotografie">
      Copia di fotografie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-transparencies-or-letterhead-topic.html#copying-transparencies-or-letterhead_it" title="Copia su carta intestata">
      Copia su carta intestata
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-on-both-sides-of-paper-topic.html#copying-on-both-sides-of-paper_it" title="Copia su entrambi i lati del foglio">
      Copia su entrambi i lati del foglio
     </a>
    </p>
    <p class="toc-2-style">
     <a href="reducing-enlarging-copies-topic.html#reducing-enlarging-copies_it" title="Riduzione o ingrandimento di copie">
      Riduzione o ingrandimento di copie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="collating-copies-topic.html#collating-copies_it" title="Fascicolazione delle copie">
      Fascicolazione delle copie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-between-copies-topic.html#placing-separator-sheets-between-copies_it" title="Inserimento di fogli separatori tra copie">
      Inserimento di fogli separatori tra copie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="saving-paper-topic.html#saving-paper_it" title="Copia di pi&ugrave; pagine su un unico foglio">
      Copia di pi&ugrave; pagine su un unico foglio
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-cards-topic.html#copying-cards_it" title="Copia di carte d'identit&agrave;">
      Copia di carte d'identit&agrave;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-copy-shortcut-topic.html#creating-copy-shortcut_it" title="Creazione di una scelta rapida di copia">
      Creazione di una scelta rapida di copia
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="E-mailing.html#E-mailing_it" title="E-mail">
     E-mail
    </a>
   </p>
   <div id="divd0e6877">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-e-mail-topic.html#using-ADF-and-scanner-glass-e-mail_it" title="Uso dell'alimentatore automatico documenti e del vetro dello scanner">
      Uso dell'alimentatore automatico documenti e del vetro dello scanner
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sending-email-topic.html#sending-email_it" title="Invio di un'e-mail">
      Invio di un'e-mail
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-email-shortcut-topic.html#creating-email-shortcut-using-control-panel_it" title="Creazione di una scelta rapida e-mail">
      Creazione di una scelta rapida e-mail
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="Faxing.html#Faxing_it" title="Fax">
     Fax
    </a>
   </p>
   <div id="divd0e6971">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-fax-topic.html#using-ADF-and-scanner-glass-fax_it" title="Uso dell'alimentatore automatico documenti e del vetro dello scanner">
      Uso dell'alimentatore automatico documenti e del vetro dello scanner
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sending-fax-topic.html#sending-fax_it" title="Invio di un fax">
      Invio di un fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scheduling-fax-topic.html#scheduling-fax_it" title="Programmazione di un fax">
      Programmazione di un fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-fax-destination-shortcut-topic.html#creating-fax-destination-shortcut_it" title="Creazione di una scelta rapida di destinazione fax">
      Creazione di una scelta rapida di destinazione fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-fax-resolution-topic.html#changing-fax-resolution_it" title="Modifica della risoluzione del fax">
      Modifica della risoluzione del fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-fax-darkness-topic.html#adjusting-fax-darkness_it" title="Regolazione dell'intensit&agrave; del fax">
      Regolazione dell'intensit&agrave; del fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-fax-log-topic.html#printing-fax-log_it" title="Stampa di un registro fax">
      Stampa di un registro fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="blocking-junk-faxes-topic.html#blocking-junk-faxes_it" title="Blocco dei fax indesiderati">
      Blocco dei fax indesiderati
     </a>
    </p>
    <p class="toc-2-style">
     <a href="holding-faxes-topic.html#holding-faxes_it" title="Fax in attesa">
      Fax in attesa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="forwarding-fax-topic.html#forwarding-fax_it" title="Inoltro di un fax">
      Inoltro di un fax
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="FTP.html#FTP_it" title="Acquisizione">
     Acquisizione
    </a>
   </p>
   <div id="divd0e7336">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-scan-topic.html#using-ADF-and-scanner-glass-scan_it" title="Uso dell'alimentatore automatico documenti e del vetro dello scanner">
      Uso dell'alimentatore automatico documenti e del vetro dello scanner
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-computer-topic.html#scanning-to-computer_it" title="Scansione su un computer">
      Scansione su un computer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-ftp-server-using-control-panel-topic.html#scanning-ftp-server-using-control-panel_it" title="Scansione su un server FTP">
      Scansione su un server FTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-FTP-shortcut-topic.html#creating-FTP-shortcut_it" title="Creazione di una scelta rapida FTP">
      Creazione di una scelta rapida FTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="s2a-scanning-to-network-folders-topic.html#s2a-scanning-to-network-folders_it" title="Acquisizione su una cartella di rete">
      Acquisizione su una cartella di rete
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-network-folder-shortcut-topic.html#creating-network-folder-shortcut_it" title="Creazione di una scelta rapida per una cartella di rete">
      Creazione di una scelta rapida per una cartella di rete
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-flash-drive-topic.html#scanning-to-flash-drive_it" title="Acquisizione su un'unit&agrave; flash">
      Acquisizione su un'unit&agrave; flash
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="understanding-printer-menus-chapter.html#understanding-printer-menus-chapter_it" title="Utilizzo dei menu della stampante">
     Utilizzo dei menu della stampante
    </a>
   </p>
   <div id="divd0e7639">
    <p class="toc-2-style">
     <a href="menu-map-mfp-topic.html#menu-map-mfp_it" title="Mappa dei menu">
      Mappa dei menu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e8020" title="Periferica">
      Periferica
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e10354" title="Stampa">
      Stampa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e11517" title="Carta">
      Carta
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copy-defaults-topic.html#d0e11877" title="Copia">
      Copia
     </a>
    </p>
    <p class="toc-2-style">
     <a href="fax-defaults-subgroup.html#d0e12449" title="Fax">
      Fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="email-setup-topic.html#d0e14877" title="E-mail">
      E-mail
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ftp-defaults-topic.html#d0e15893" title="FTP">
      FTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="flash-drive-scan-topic.html#d0e16539" title="Unit&agrave; USB">
      Unit&agrave; USB
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e17340" title="Rete/Porte">
      Rete/Porte
     </a>
    </p>
    <p class="toc-2-style">
     <a href="login-methods-subgroup.html#d0e19484" title="Protezione">
      Protezione
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cloud-services-enrollment-topic.html#d0e20634" title="Servizi cloud">
      Servizi cloud
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e20691" title="Report">
      Report
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-menu-topic.html#troubleshooting-menu_it" title="Risoluzione dei problemi">
      Risoluzione dei problemi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="forms-merge-topic.html#forms-merge_it" title="Forms Merge">
      Forms Merge
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-topic.html#printing-menu-settings-page_it" title="Stampa della Pagina impostazioni menu">
      Stampa della Pagina impostazioni menu
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_it" title="Manutenzione della stampante">
     Manutenzione della stampante
    </a>
   </p>
   <div id="divd0e21235">
    <p class="toc-2-style">
     <a href="checking-status-of-parts-and-supplies-topic.html#checking-status-of-parts-and-supplies_it" title="Verifica dello stato dei componenti e dei materiali di consumo della stampante">
      Verifica dello stato dei componenti e dei materiali di consumo della stampante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-supply-notifications-topic.html#configuring-supply-notifications_it" title="Configurazione delle notifiche dei materiali di consumo">
      Configurazione delle notifiche dei materiali di consumo
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-e-mail-alert-topic.html#setting-up-e-mail-alert_it" title="Impostazione degli avvisi e-mail">
      Impostazione degli avvisi e-mail
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-reports-topic.html#viewing-reports_it" title="Visualizzazione dei rapporti">
      Visualizzazione dei rapporti
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-supplies-group.html#ordering-supplies-group_it" title="Ordinazione di componenti e materiali di consumo">
      Ordinazione di componenti e materiali di consumo
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-toner-cartridge-topic.html#d0e21568" title="Sostituzione di componenti e materiali di consumo">
      Sostituzione di componenti e materiali di consumo
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#d0e21911" title="Pulizia dei componenti della stampante">
      Pulizia dei componenti della stampante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-power-save-mode-settings-topic.html#d0e22058" title="Risparmio energetico e di carta">
      Risparmio energetico e di carta
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-printer-topic.html#moving-printer_it" title="Spostamento della stampante in un'altra posizione">
      Spostamento della stampante in un'altra posizione
     </a>
    </p>
    <p class="toc-2-style">
     <a href="shipping-printer-topic.html#shipping-printer_it" title="Spedizione della stampante">
      Spedizione della stampante
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_it" title="Risoluzione dei problemi">
     Risoluzione dei problemi
    </a>
   </p>
   <div id="divd0e22212">
    <p class="toc-2-style">
     <a href="print-quality-problems-picker-topic.html#print-quality-problems-picker_it" title="Problemi di qualit&agrave; di stampa">
      Problemi di qualit&agrave; di stampa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-error-codes-topic.html#printer-error-codes_it" title="Codici di errore della stampante">
      Codici di errore della stampante
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printing-problems.html#solving-printing-problems_it" title="Problemi di stampa">
      Problemi di stampa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-printer-not-responding-topic.html#trb-printer-not-responding_it" title="La stampante non risponde">
      La stampante non risponde
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-unable-to-read-flash-drive-topic.html#trb-unable-to-read-flash-drive_it" title="Impossibile leggere l'unit&agrave; flash">
      Impossibile leggere l'unit&agrave; flash
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-usb-port-topic.html#enabling-usb-port_it" title="Attivazione della porta USB">
      Attivazione della porta USB
     </a>
    </p>
    <p class="toc-2-style">
     <a href="clearing-jams.html#clearing-jams_it" title="Rimozione degli inceppamenti">
      Rimozione degli inceppamenti
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e25885" title="Problemi di connessione di rete">
      Problemi di connessione di rete
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-detect-internal-option-topic.html#d0e26113" title="Problemi delle opzioni hardware">
      Problemi delle opzioni hardware
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e26261" title="Problemi con i materiali di consumo">
      Problemi con i materiali di consumo
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-envelope-seals-when-printing-topic.html#d0e26384" title="Problemi di alimentazione della carta">
      Problemi di alimentazione della carta
     </a>
    </p>
    <p class="toc-2-style">
     <a href="disabling-smtp-server-not-setup-error-topic.html#d0e26750" title="Problemi di invio delle e-mail">
      Problemi di invio delle e-mail
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-caller-id-not-shown-topic.html#d0e26844" title="Problemi di invio dei fax">
      Problemi di invio dei fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-scan-to-computer-topic.html#d0e27489" title="Problemi di acquisizione">
      Problemi di acquisizione
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_it" title="Come contattare l'assistenza clienti">
      Come contattare l'assistenza clienti
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="recycle-dispose-chapter.html#recycle-dispose-chapter_it" title="Riciclo e smaltimento">
     Riciclo e smaltimento
    </a>
   </p>
   <div id="divd0e28268">
    <p class="toc-2-style">
     <a href="recycling-lexmark-products-topic.html#recycling-lexmark-products_it" title="Riciclaggio dei prodotti Lexmark">
      Riciclaggio dei prodotti Lexmark
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling-lexmark-packaging-topic.html#recycling-lexmark-packaging_it" title="Riciclo del materiale di imballaggio Lexmark">
      Riciclo del materiale di imballaggio Lexmark
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_it" title="Avvertenze">
     Avvertenze
    </a>
   </p>
   <div id="divd0e28305">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28308" title="Informazioni sul prodotto">
      Informazioni sul prodotto
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28325" title="Nota sull'edizione">
      Nota sull'edizione
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_it" title="Marchi">
      Marchi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_it" title="Informazioni sulla licenza">
      Informazioni sulla licenza
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_it" title="Livelli di emissione dei rumori">
      Livelli di emissione dei rumori
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#weee-directive_it" title="Direttiva WEEE (Rifiuti di apparecchiature elettriche ed elettroniche)">
      Direttiva WEEE (Rifiuti di apparecchiature elettriche ed elettroniche)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28431" title="Batteria ricaricabile agli ioni di litio">
      Batteria ricaricabile agli ioni di litio
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#eu-battery-directive-2023-1542_it" title="Normativa (UE) 2023/1542">
      Normativa (UE) 2023/1542
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28469" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_it" title="Smaltimento dei prodotti">
      Smaltimento dei prodotti
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_it" title="Restituzione delle cartucce Lexmark per il riuso o il riciclo">
      Restituzione delle cartucce Lexmark per il riuso o il riciclo
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_it" title="Avviso sensibilit&agrave; ad elettricit&agrave; statica">
      Avviso sensibilit&agrave; ad elettricit&agrave; statica
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_it" title="ENERGY STAR">
      ENERGY STAR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_it" title="Informazioni sulle temperature">
      Informazioni sulle temperature
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-notice_it" title="Avvertenze sui prodotti laser">
      Avvertenze sui prodotti laser
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_it" title="Consumo di energia">
      Consumo di energia
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#regulatory-notices-for-telecommunication-terminal-equipment_it" title="Avviso sulle normative per le apparecchiature terminali per le telecomunicazioni">
      Avviso sulle normative per le apparecchiature terminali per le telecomunicazioni
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28733" title="Avvisi sulle normative per i prodotti wireless">
      Avvisi sulle normative per i prodotti wireless
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#modular-component-notice_it" title="Avvertenza sui componenti modulari">
      Avvertenza sui componenti modulari
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#exposure-to-radio-frequency-radiation_it" title="Esposizione alle radiazioni di radiofrequenza">
      Esposizione alle radiazioni di radiofrequenza
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e28758" title="Conformit&agrave; alle direttive dell'Unione Europea (UE)">
      Conformit&agrave; alle direttive dell'Unione Europea (UE)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#european-community-ec-directives-conformity-class-a_it" title="Conformit&agrave; alle direttive dell'Unione Europea (UE)">
      Conformit&agrave; alle direttive dell'Unione Europea (UE)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#radio-interference-notice_it" title="Informazioni sulle interferenze radio">
      Informazioni sulle interferenze radio
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue